<script setup lang="ts">
/* __placeholder__ */
import type { PostOrPage } from '@tryghost/content-api';
import { useDateFormat } from '@vueuse/core';

const props = defineProps<{ post: PostOrPage }>();

const formatDate = computed(() => {
  return useDateFormat(new Date(props.post.published_at as string), 'D MMMM, YYYY');
});
</script>

<template>
  <div class="flex max-h-[84px] flex-row justify-between gap-x-2 md:max-lg:flex-col">
    <div class="w-full">
      <NuxtLink :to="`/customer-success-glossary/${post.slug}`">
        <h2 class="mb-2 line-clamp-2 text-lg font-extrabold text-[#3a3a3c]">
          {{ post.title }}
        </h2>
      </NuxtLink>
      <p class="text-sm text-[#3a3a3c]">{{ formatDate.value }}</p>
    </div>
  </div>
</template>

<style scoped></style>
